import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { t } from '../../../../modules/infra/i18n';
import TotalSales from './totalSales';
import TaxesCollected from './taxesCollected';
import AmountsTable from './amountsTable';
import {
  getProductSalesReport,
  getProductSalesSum,
  getProductRefunds,
} from '../selectors';
import { canUseGiftCards } from '../../../auth/selectors';

const ProductReport = ({ barberSummary, refundAmount, showGiftCards, barberReports }) => (
  <div>
    <div display-if={barberReports.length}>{t('reports:appointments_report.no_data')}</div>
    <h3>{t('reports:product_sales_report.total_product_sales')}</h3>
    <TotalSales report={barberSummary} showGiftCards={showGiftCards} />
    <h3>{t('reports:product_sales_report.taxes_collected_refunds')}</h3>
    <TaxesCollected report={barberSummary} refundAmount={refundAmount} />
    <AmountsTable
      barberReports={barberReports}
      summary={barberSummary}
      showGiftCards={showGiftCards}
    />
  </div>
);

const mapStateToProps = state => ({
  barberReports: getProductSalesReport(state),
  barberSummary: getProductSalesSum(state),
  refundAmount: getProductRefunds(state),
  showGiftCards: canUseGiftCards(state),
});

ProductReport.propTypes = {
  barberReports: PropTypes.array.isRequired,
  barberSummary: PropTypes.object.isRequired,
  refundAmount: PropTypes.number.isRequired,
  showGiftCards: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(ProductReport);
